const prefix = 'AI_CHATS/';

const AI_CHATS_LIST_TAG = `${prefix}LIST`;
export const AI_CHAT_MESSAGES_TAG = `${prefix}MESSAGES`;

export default AI_CHATS_LIST_TAG;
